var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(this.$route.name !== 'login')?_c('appHeader'):_vm._e(),_c('router-view'),_c('vue-snotify')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }